/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const HeroiconsOutlineArrowTrendingUp = ({ className }) => {
  return (
    <svg
      className={`heroicons-outline-arrow-trending-up ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M2.25 18L9 11.25L13.3064 15.5564C14.5101 13.1881 16.5042 11.2023 19.1203 10.0375L21.8609 8.81732M21.8609 8.81732L15.9196 6.53668M21.8609 8.81732L19.5802 14.7586"
        stroke="#7041F1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};
